import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { useApplicationChat } from '../context';
import { useProjectSourceUpload } from './upload.js';

type SourcesView = ReturnType<typeof useProjectSourceUpload> & {
  setShouldLoadSources: (visible: boolean) => void;
};
const SourcesContext = createContext<SourcesView | null>(null);

/** Visibility controls reads, not the lifetime of in-flight project uploads. */
export const SourcesProvider = ({ userId, children }: { userId?: string; children?: ReactNode }) => {
  const { realApi, workspaceLocation } = useApplicationChat();
  const [shouldLoadSources, setShouldLoadSources] = useState(false);
  const sources = useProjectSourceUpload({ sourceAPI: realApi.sourceAPI,
    projectId: workspaceLocation.effectiveProjectId, userId, shouldLoadSources });
  const value = useMemo(() => ({ ...sources, setShouldLoadSources }), [sources]);
  return <SourcesContext.Provider value={value}>{children}</SourcesContext.Provider>;
};
export const useSources = (): SourcesView => {
  const value = useContext(SourcesContext);
  if (!value) throw new Error('Project sources require the application provider');
  return value;
};
